export class VendorResponse {
	id: number;
	company: number;
	metaVendor: any;
	code: string;
	nit: string;
	cui: any;
	name: string;
	merchantCompany: any;
	address: any;
	contactName: any;
	contactMail: any;
	contactPhone: any;
	contactCellphone: any;
	taxRegime: number;
	provider: boolean;
	inventarios: boolean;
	extranjero: boolean;
	providerAccount: any;
	providerCreditDays: number;
	client: boolean;
	clientAccount: any;
	clientCreditDays: any;
	enabled: boolean;
	clientCredit: any;
	availableClientCredit: any;
	dpi: any;
	priceList: any;
	clientGroup: any;
	creationDate: number;
	canEdit: boolean;
	affiliate: boolean;
	provIn?: boolean;
	percentage: number;
	billingNit?: string;
	billingName?: string;
	place?: string;

	billingRequest: VendorBillingNitRequest[] = [];
	constructor() {

	}
}

export class Regimes {
	id: number;
	name: string;
	nameAbrev: string;

	constructor() {

	}
}

export class EditCategoryVendorRequest {
	accountId: number;
	active: boolean;
	companyId: number;
	creationDate: number;
	id: number;
	name: string;
	validated: boolean;
}

export class CategoryAccountRequest {
	accountId: number;
	name: string;
}

export class VendorBankRequest {
	id?: number;
	typeBank: number;
	idBank: number;
	idVendor: number;
	accountNumber: string;
	international: boolean;
}

export class VendorBillingNitRequest {
    billingNit: string = "";
    billingName: string = "";
}